// Service-provider blueprint options (languages, coverage, delivery, pricing) — shared by
// SellMachine, ListingDetail and Expert forms/detail. Values are canonical ids stored in DB.
import { optLabel, findOptLabel } from "@/lib/listingDyn";

export const LANGUAGES = [
  { value: "ro", ro: "Română", hu: "Román", en: "Romanian" },
  { value: "hu", ro: "Maghiară", hu: "Magyar", en: "Hungarian" },
  { value: "en", ro: "Engleză", hu: "Angol", en: "English" },
  { value: "de", ro: "Germană", hu: "Német", en: "German" },
  { value: "fr", ro: "Franceză", hu: "Francia", en: "French" },
  { value: "es", ro: "Spaniolă", hu: "Spanyol", en: "Spanish" },
  { value: "zh", ro: "Chineză", hu: "Kínai", en: "Chinese" },
  { value: "hi", ro: "Hindi", hu: "Hindi", en: "Hindi" },
  { value: "ar", ro: "Arabă", hu: "Arab", en: "Arabic" },
];

export const DELIVERY_CHANNELS = [
  { value: "on_site", ro: "La sediul clientului", hu: "Ügyfél telephelyén", en: "On-site (client)" },
  { value: "in_shop", ro: "La sediul prestatorului", hu: "Szolgáltató telephelyén", en: "In-shop" },
  { value: "remote", ro: "Remote / Online", hu: "Távoli / Online", en: "Remote / Online" },
  { value: "hybrid", ro: "Hibrid", hu: "Hibrid", en: "Hybrid" },
];

export const PRICING_TYPES = [
  { value: "per_ora", ro: "Pe oră", hu: "Óradíj", en: "Per hour" },
  { value: "per_proiect", ro: "Pe proiect", hu: "Projektenként", en: "Per project" },
  { value: "per_km", ro: "Pe km", hu: "Kilométerenként", en: "Per km" },
  { value: "abonament", ro: "Abonament", hu: "Előfizetés", en: "Subscription" },
  { value: "la_cerere", ro: "La cerere", hu: "Kérésre", en: "On request" },
];

export const CURRENCIES = ["RON", "EUR"];

export { optLabel, findOptLabel };

// Human-readable coverage summary from a stored coverage object.
export const coverageSummary = (cov, t) => {
  if (!cov) return "";
  const parts = [];
  if (cov.base_city) parts.push(cov.base_city);
  if (cov.radius_km) parts.push(`+${cov.radius_km} km`);
  if (cov.national) parts.push(t("svc.national"));
  if (cov.international) parts.push(t("svc.international"));
  return parts.join(" · ");
};

// Human-readable pricing summary.
export const pricingSummary = (p, lng, t) => {
  if (!p || !p.pricing_type) return "";
  const type = findOptLabel(PRICING_TYPES, p.pricing_type, lng);
  if (p.pricing_type === "la_cerere") return type;
  const rate = p.rate != null ? `${p.rate} ${p.currency || "RON"}` : "";
  const range = (p.min_budget != null || p.max_budget != null)
    ? ` (${p.min_budget ?? "?"}–${p.max_budget ?? "?"} ${p.currency || "RON"})` : "";
  return [rate, type].filter(Boolean).join(" / ") + range;
};
